// extracted by mini-css-extract-plugin
module.exports = {"Logo":"header-module--Logo--SoSHU","Footer":"header-module--Footer--mvH9o","Lord":"header-module--Lord--v2M1K"};